import React from "react";
import classes from "./Tnc.module.css";
import { useNavigate } from "react-router-dom";

const Tnc = () => {
  const navigate = useNavigate();

  return (
    <div className={classes.main_container}>
    <div className={classes.container}>
    <p className={classes.title}>Terms & Conditions</p>
    <br />
    <p className={classes.desc}>H2N Kidoffy is a vibrant educational platform designed to introduce little kid learners to the basics through interactive content. Children can explore ABCs, shapes, animal names, counting, occupations, and days of the week etc.</p>
    <ul>
    <li>The service cost is KSH 15/day.</li>
    <li>Your Subscription will be renewed at KSH 15/day, automatically until you unsubscribe.</li>
    <li>You can unsubscribe from H2n Kidoffy, anytime.</li>
    <li>You must be more than 14+ to have received permission from your parents or guardian who is authorized to pay your bill.</li>
    <li>All data-enabled features and smartphone users can enjoy full service.</li>
    <li>Customer can access the content at any time during the subscription validity period.</li>
    </ul>
    </div>
    </div>
  );
};

export default Tnc;
